var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#0E0E0E",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3971 10.0538L10.4697 9.96967C10.7359 9.7034 11.1526 9.6792 11.4462 9.89705L11.5303 9.96967L16.5 14.939L21.4697 9.96967C21.7359 9.7034 22.1526 9.6792 22.4462 9.89705L22.5303 9.96967C22.7966 10.2359 22.8208 10.6526 22.6029 10.9462L22.5303 11.0303L17.561 16L22.5303 20.9697C22.7966 21.2359 22.8208 21.6526 22.6029 21.9462L22.5303 22.0303C22.2641 22.2966 21.8474 22.3208 21.5538 22.1029L21.4697 22.0303L16.5 17.061L11.5303 22.0303C11.2641 22.2966 10.8474 22.3208 10.5538 22.1029L10.4697 22.0303C10.2034 21.7641 10.1792 21.3474 10.3971 21.0538L10.4697 20.9697L15.439 16L10.4697 11.0303C10.2034 10.7641 10.1792 10.3474 10.3971 10.0538L10.4697 9.96967L10.3971 10.0538Z",
    fill: "#0E0E0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.30a8857e4422a8d244d78b7afe13fb3c.svg";
export { ForwardRef as ReactComponent };